import { render, staticRenderFns } from "./ParalizacionesTable.vue?vue&type=template&id=046972cd&scoped=true"
import script from "./ParalizacionesTable.vue?vue&type=script&lang=js"
export * from "./ParalizacionesTable.vue?vue&type=script&lang=js"
import style0 from "./ParalizacionesTable.vue?vue&type=style&index=0&id=046972cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046972cd",
  null
  
)

export default component.exports